import React from 'react';
import { ErrorMessageTemplate } from './error-handler-template';
import { MessengerLauncherWrapper } from 'works/legacy/components/messenger-launcher-wrapper';

export const StandardUnexpectedErrorMessage = () => (
  <ErrorMessageTemplate
    title="Umm, something went wrong."
    imageName="error-unexpected"
    imageAlt="Image of blank document within a crying emoji."
  >
    <>
      Refresh the page and try again, or{' '}
      <MessengerLauncherWrapper>chat with support</MessengerLauncherWrapper> for
      further assistance.
    </>
  </ErrorMessageTemplate>
);

export const ContextualUnexpectedErrorMessage = () => (
  <p>Error, please try again.</p>
);

export const NotificationUnexpectedErrorMessage = () => (
  <p>
    <strong>Something went wrong.</strong> Refresh the page and try again, or{' '}
    <MessengerLauncherWrapper>chat with support</MessengerLauncherWrapper> for
    further assistance.
  </p>
);
